import React, { Component } from 'react';

import { Col, Row } from 'reactstrap';
import graphLogo from '../../../../public/img/GARP_logo.png';
import ChapterCard from '../../../Components-2025/QuestionBank/ChapterCards';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import questionBankCardIcon from '../../../../public/img/question_bank/icon2.svg';
import ComponentHeader from '../../../common/ComponentHeader';
import { messages } from '../../../common/messages';
import {
  chapterIdKey,
  chapterNameKay,
  freeQuestionsCountKey,
  premiumQuestionsCountKey,
  questionTableKey,
  readingIdKey,
  totalReadingKey,
} from './ApiAttributesKays';
import ApiServiceProvider from './ApiService';

import { showInformation } from '../../../common/toast';
import appRoutes from '../../config/AppRoutes';

export class QuestionBank extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      chapterId: '',
      questionId: '',
      isLoading: true,
      isButtonDisablePart1: false,
      isButtonDisablePart2: false,
      chapterDataPart1:[],
      chapterDataPart2: [],
      selectedExamSubscriptionDetails: {},
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
  componentDidMount = async () => {
      this.getChapterWiseCount({ level: 1 });
      this.getChapterWiseCount({ level: 2 });
  };
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================
  



  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================

  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
  getChapterWiseCount = async level => {
    const result = await ApiServiceProvider['fetchChaptersWithPremiumAndFreeCount'](level);
    if (result.success) {
      this.setState({
        isLoading: false,
        [`chapterDataPart${level.level}`]: result.data //* we will uncomment when api is ready
      });
    }
    this.setState({ isLoading: false });
  };


  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================

  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
  redirectToQuestionBank = async level => {
    this.setState({ [`isButtonDisablePart${level.level}`]: true });
    const result = await ApiServiceProvider['fetchLastAnsweredQuestion'](level);
    this.setState({ [`isButtonDisablePart${level.level}`]: false });

    //* FIRST OF ALL CHECK THE REDIRECTION
    if (result.success) {
      const { data } = result; 
      const { router } = this.context;
      if(data){
        router.push({
        pathname: appRoutes.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(
          ':level',
          level.level,
        ).replace(':readingId', data[questionTableKey][readingIdKey]).replace(':questionId', data[questionTableKey].id),
      });
     }else {
      showInformation(messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
    }
    } else {
      showInformation(messages.LAST_ATTEMPTED_QUESTION_NOT_AVAILABLE);
    }
  };
  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================
  render() {
    const { state , context } = this;
    const {  isLoading, chapterDataPart1, chapterDataPart2 } = state;
    const { router } = context;

    return (
      <div className='animated fadeIn'>
        <ComponentHeader title={messages.QUESTION_BANK} className='frm_title_logo_wrap'>
          <img
            src={graphLogo}
            className='garpLogo'
            alt='full logo'
          />
        </ComponentHeader>

        {/*//*================================================={{ PART I AND II START HERE }}================================================  */}
        {['1', '2'].map(level => (
          <div key={level}>
            <ComponentHeader title={messages[`FRM_TOPIC_PART_${level}`]}>
              <button
                className='btn btn-primary pointer_class'
                onClick={() => this.redirectToQuestionBank({ level })}
                disabled={state[`isButtonDisablePart${level}`]}
              >
                {state[`isButtonDisablePart${level}`] && (
                  <i className='fa fa-spinner fa-spin mr-1' />
                )}
                {messages.GO_TO_MY_LAST_QUESTION_ANSWERED}
              </button>
            </ComponentHeader>
            <LoaderWrapper isLoading={isLoading}>
              <Row>
                <Col className='seperator-block-wrap'>
                  <div className='card'>
                    <div className='card-block'>
                      <Row>
                        {state[`chapterDataPart${level}`].length &&
                          state[`chapterDataPart${level}`].map(item => {
                            return (
                              <ChapterCard
                                onClick={() =>
                                  router.push({
                                    pathname: appRoutes.FRM_V2_QUESTION_BANK_READING_LIST.replace(
                                      ':level',
                                      level,
                                    ).replace(':chapterId', item[chapterIdKey]),
                                    state: { chapterDataPart1, chapterDataPart2 },
                                  })
                                }
                                key={item[chapterIdKey]}
                                headerImage={questionBankCardIcon}
                                headerImageWidth={55}
                                chapterNumber={item[chapterIdKey]}
                                chapterName={item[chapterNameKay]}
                                totalReadings={item[totalReadingKey]}
                                freeQuestionsCount={item[freeQuestionsCountKey]}
                                premiumQuestionsCount={item[premiumQuestionsCountKey]}
                                {...this.props}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </LoaderWrapper>
          </div>
        ))}
        {/*//*================================================={{ PART I AND II ENDED HERE }}================================================  */}
      </div>
    );
  }
}

export default QuestionBank;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/index.jsx